




































































import { Component } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import { InstitutionAccountSettingsModule } from '@/store/Accounts/InstitutionAccountSettingsModule';
import InstitutionAccountSettingsEdit from '@/components/Accounts/InstitutionAccounts/Settings/InstitutionAccountSettingsEdit.vue';
import PermissionUtils from '@/lib/permissionUtils';

@Component({ name: 'InstitutionAccountSettings', components: { InstitutionAccountSettingsEdit } })
export default class extends SaascadaVue {

    PermissionUtils = PermissionUtils;

    get settings() {
        return InstitutionAccountSettingsModule.institutionalAccountSettings;
    }

}
